import { useEffect, useState } from "react";
import styles from "../styles/style.module.css";
import { APP_ROUTES, LOCAL_CONSTANTS } from "../../../lib/constants";
import { IMAGES } from "../../../assets/images";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { S3_BUCKET_URL } from "../../../config";

interface UserListProp {
  loading: boolean;
  users: any,
  partnerType: any
}

const UserList = ({ loading, users, partnerType }: UserListProp) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // State to check if current path includes "roamwebsite"
  const [isRoamWebsite, setIsRoamWebsite] = useState(false);
  
  useEffect(() => {
    // Check if the current pathname includes "roamwebsite"
    const currentPath = location.pathname;
    const includesRoamWebsite = currentPath.includes('roamwebsite');
    setIsRoamWebsite(includesRoamWebsite);
  }, [location.pathname]);
  console.log(isRoamWebsite,'isRoamWebsite');
  

  return (
    <div className={styles.scrollTable}>
      <table>
        <thead>
          <tr>
            <th>#</th>
            {partnerType == LOCAL_CONSTANTS.PARTNERS.VFS &&
              <>
                <th>Name</th>
                <th>Phone Number</th>
              </>
            }
         {isRoamWebsite ? <th>Name</th> : ""}
            <th>Email</th>
            {isRoamWebsite ? <th>Phone Number</th> : ""}
          {isRoamWebsite ?  <th>Sim Type</th> : ""}
          {isRoamWebsite ?    <th>Sim Number</th> : ""}
           {isRoamWebsite ?    <th>IMEI</th> : ""}
           {isRoamWebsite ?    <th>EID</th> : ""}
           {isRoamWebsite ?    <th>Handset Model No</th> : ""}  
           {isRoamWebsite ?    <th>Passport Front</th> : ""}
           {isRoamWebsite ?    <th>Passport Back</th> : ""}
           {isRoamWebsite ?    <th>Visa</th> : ""}
         {isRoamWebsite ? "" :   (partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX ? <th>Name</th> : <th>Registration Source</th>)}
            {isRoamWebsite ? "" :   (partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX ? <th>Phone Number</th> : "")}
            {isRoamWebsite ? "" :   (partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX ? <th>Handset Model No</th> : "")}
            {isRoamWebsite ? "" :   (partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX ? "" : <th>Payment Status</th>)}
            {partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX && <th>Date</th>}
            {partnerType == LOCAL_CONSTANTS.PARTNERS.VFS &&
              <>
               <th>Buying Date</th>
                <th>travelling Date</th>
                <th>Return Date</th>
                <th>Fapio Needed</th>
              </>
            }
            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={7} align="center" className={styles.loadingText}>
                {LOCAL_CONSTANTS.loading}
              </td>
            </tr>
          )}
          {!loading && users.list.length === 0 && (
            <tr>
              <td colSpan={7} align="center">
                No User Found
              </td>
            </tr>
          )}
          {!loading &&
            users.list.map((item: any, index: number) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                {partnerType == LOCAL_CONSTANTS.PARTNERS.VFS &&
                  <>
                    <td>
                      <img
                        width={10}
                        height={10}
                        src={
                          item.avatar && item.avatar.length
                            ? item.avatar
                            : IMAGES.RegisteredUserImage
                        }
                        alt="userImage"
                      />
                      {item.firstName} {item.lastName || LOCAL_CONSTANTS.na}
                    </td>
                    <td>{item.countryCode} {item.phoneNumber || LOCAL_CONSTANTS.na}</td>
                  </>
                }
                {isRoamWebsite ? <td>{item?.firstName} {item?.lastName || LOCAL_CONSTANTS.na}</td> : ""}
                <td>{item?.email || LOCAL_CONSTANTS.na}</td>
                {isRoamWebsite ? <td> {item?.phoneNumber || LOCAL_CONSTANTS.na}</td> : ""}
                {isRoamWebsite ? <td>{item?.simType == 1 ? "Physical" : item?.simType == 2 ? "Esim" : LOCAL_CONSTANTS.na}</td> : ""}
                {isRoamWebsite ? <td>{item?.simNumber || LOCAL_CONSTANTS.na}</td> : ""}

                {isRoamWebsite ? <td>{item?.imei || LOCAL_CONSTANTS.na}</td> : ""}
                {isRoamWebsite ? <td>{item?.eid || LOCAL_CONSTANTS.na}</td> : ""}
                {isRoamWebsite ? <td>{item?.handsetModelNo || LOCAL_CONSTANTS.na}</td> : ""}
                {isRoamWebsite ? <td><a href={S3_BUCKET_URL + item?.documents?.passportFront || LOCAL_CONSTANTS.na} target="_blank">{item?.documents?.passportFront && "View" || LOCAL_CONSTANTS.na}</a></td> : ""}
                {isRoamWebsite ? <td><a href={S3_BUCKET_URL + item?.documents?.passportBack || LOCAL_CONSTANTS.na} target="_blank">{item?.documents?.passportBack && "View" || LOCAL_CONSTANTS.na}</a></td> : ""}
                {isRoamWebsite ? <td><a href={S3_BUCKET_URL + item?.documents?.visa || LOCAL_CONSTANTS.na} target="_blank">{item?.documents?.visa && "View" || LOCAL_CONSTANTS.na}</a></td> : ""}
                {isRoamWebsite ? "" :   (partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX ? <td>{item?.firstName} {item?.lastName || LOCAL_CONSTANTS.na}</td> : <td>{item?.registrationType == 1 ? "Normal" : item?.registrationType == 2 ? "Free" : LOCAL_CONSTANTS.na}</td>)}
                {isRoamWebsite ? "" :   (partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX ? <td>{item?.phoneNumber || LOCAL_CONSTANTS.na}</td> : "")}
                {isRoamWebsite ? "" :   (partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX ? <td>{item?.handsetModelNo || LOCAL_CONSTANTS.na}</td> : "")}
                {isRoamWebsite ? "" :   (partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX ? "" : <td>{item?.paymentProof === "" ? <span className="text-warning">Free</span> : <span className="text-success">Paid</span>}</td>)}
                {partnerType === LOCAL_CONSTANTS.PARTNERS.GLOBALTIX && <td>{item?.createdAt ? moment(item?.createdAt).format("YYYY-MM-DDTHH:mm") : "N/A"}</td>}
                {partnerType == LOCAL_CONSTANTS.PARTNERS.VFS &&
                  <>
                   <td>{item?.createdAt ? moment(item?.createdAt).format(LOCAL_CONSTANTS.dateFormat) : "N/A"}</td>
                    <td>{item?.travellingDate ? moment(item?.travellingDate).format(LOCAL_CONSTANTS.dateFormat) : "N/A"}</td>
                    <td>{item?.returnDate ? moment(item?.returnDate).format(LOCAL_CONSTANTS.dateFormat) : "N/A"}</td>
                    <td>{item?.fapio || "N/A"}</td>
                  </>
                }
                {/* <td><a onClick={() => navigate(`/partners/${item?._id}/orders-list`)}>View Orders</a></td> */}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default UserList